<template>
  <div class="page-container">
    <Hero title="Thanks to all" imageUrl="Nicole+Jon-46.jpg" altText="Engagement photo courtesy of Henry Cotton"/>
    <div class="content-container">
        <section class="divider">
            <h2 class="title">Check out our registries</h2>
            <a href="https://www.macys.com/wgl/registry/guest/7219016" target="_blank"><button class="button">Macy's</button></a>
            <span class="spacer"></span>
            <a href="https://www.myregistry.com/giftlist/cote-nguyen-wedding-2022" target="_blank"><button class="button">Costco</button></a>
            <span class="spacer"></span>
            <a href="https://www.amazon.com/wedding/jonathan-nguyen-nicole-cote--july-2021/registry/3FBSD3HCY42B3" target="_blank"><button class="button">Amazon</button></a>
        </section>
        <section>
            <h2 class="title">Another way to give</h2>
            <p class="subtitle">Rather than buying us gifts from the registry, consider contributing to our honeymoon fund! Whatever you decide to gift us, we greatly appreciate it. Thank you!!</p>
        </section>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Gifts',
  components: {
    Hero,
    Footer
  }
}
</script>

<style lang="scss" scoped>
    .content-container {
        max-width: 860px;
        padding: 80px 20px;
        margin: 0 auto;

        .divider {
            padding-bottom: 40px;
        }

        .title {
            font-size: 2.5rem;
            margin: 0;
            padding-bottom: 24px;
            font-weight: 100;
        }
        .subtitle {
            font-size: 1.125rem;
            margin: 0;
            padding-bottom: 32px;
        }
        .button {
              padding: 16px 32px;
              text-align: center;
              text-decoration: none;
              display: inline-block;
              font-size: 0.875rem;
              margin: 1rem auto 0 auto;
              transition-duration: 0.4s;
              cursor: pointer;
              background-color: #F5F5F5;
              color: #988ABD;
              border: 2px solid #988ABD;
              width: fit-content;
              font-weight: bold;
              letter-spacing: 0.1rem;
              text-transform: uppercase;
          }

          .button:hover {
            background-color: #988ABD;
            color: #FFF;
          }

          .button:focus {
            outline: none;
          }

          .spacer {
            padding: 0 4px;
          }
    }

    @media only screen and (max-width: 768px) {
      .content-container {
        padding: 40px 20px;

        .title {
          font-size: 2rem;
        }
      }
    }
</style>
